/**
 * ADMIN-VERSION-1 — read /version.json. Never invent a SHA or a clock.
 */
export const VERSION_UNAVAILABLE = "Version unavailable";

export type AdminVersion = {
  shortSha: string;
  fullSha: string;
  buildTime: string;
};

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

export function parseVersionPayload(value: unknown): AdminVersion | null {
  if (!isRecord(value)) return null;
  const sha = value.sha;
  const buildTime = value.buildTime;
  if (typeof sha !== "string" || sha.length === 0) return null;
  if (typeof buildTime !== "string" || buildTime.length === 0) return null;
  return { shortSha: sha.slice(0, 7), fullSha: sha, buildTime };
}
